<p-toast></p-toast>

<div class="farmer-app-for-change-request-container">

    <!-- Hidden on Small screens -->
    <!-- Visible on Small screens -->
    <!-- <div class="block md:hidden">
        <div class="landing">
            <div class="header-container">
                <div class="icon">
                </div>
                <div class="header">
                    <p>Welcome to</p>
                    <p>MICADA mobile application</p>
                </div>
                <div class="subheader">
                    <p> Efficient and elegant way to verify site</p>
                </div>
            </div>
        </div>
        <div style="padding: 0 1em;">
            <p-card styleClass="p-card-shadow my-2 widthFull" *ngFor="let item of physicalVerficationApplications"
                (click)="selectPhysicalVerAppln(item)">
                <table cellspacing="10">
                    <tr>
                        <td class="fontXl"><b>App ID</b></td>
                        <td class="fontXl">
                            {{item.AppID}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>Date Of Reg</b></td>
                        <td>
                            {{item.DateOfReg}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>Farmer Name</b></td>
                        <td>
                            {{item.FarmerName}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>Village</b></td>
                        <td>
                            {{item.Village}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>Vendor Name</b></td>
                        <td>
                            {{item.VendorName}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>Scheme</b></td>
                        <td>
                            {{item.Scheme}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>AutoId</b></td>
                        <td>
                            {{item.AutoId}}
                        </td>
                    </tr>
                </table>
            </p-card>
        </div>
    </div> -->

    <!-- Hidden on small screens -->
    <div>
        <p-card styleClass="p-card-shadow">
            <h5 class="mt-0">{{'FARMER_APPLICATION_FOR_CHANGE_REQUEST'| translate}}</h5>
            <div>
                <p-table #dt [value]="changeReqApplications" [rows]="10" [paginator]="true"
                    [globalFilterFields]="['AppID','DateOfReg','FarmerName','Village', 'VendorName', 'Scheme', 'AutoId']"
                    responsiveLayout="scroll" [rowHover]="true" dataKey="id"
                    currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                    [showCurrentPageReport]="true">
                    <ng-template pTemplate="caption">
                        <div class="flex align-items-center justify-content-between">
                            <h5 class="m-0">{{'MANAGE_APPLICATIONS'| translate}}</h5>
                            <span class="p-input-icon-left">
                                <i class="pi pi-search"></i>
                                <input pInputText type="text"
                                    (input)="dt.filterGlobal($any($event.target).value, 'contains')"
                                    placeholder="{{'SEARCH'| translate}}" />
                            </span>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="header">
                        <tr>
                            <th pSortableColumn="AppID">{{'APP_ID'| translate}}
                                <p-columnFilter type="text" field="AppID" display="menu"></p-columnFilter>
                                <p-sortIcon field="AppID"></p-sortIcon>
                            </th>
                            <th pSortableColumn="DateOfReg">{{'DATE_OF_REG'| translate}}
                                <p-columnFilter type="text" field="DateOfReg" display="menu"></p-columnFilter>
                                <p-sortIcon field="DateOfReg"></p-sortIcon>
                            </th>
                            <th pSortableColumn="FarmerName">{{'FARMER_NAME'| translate}}
                                <p-columnFilter type="text" field="FarmerName" display="menu"></p-columnFilter>
                                <p-sortIcon field="FarmerName"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Caste_Description">{{'CASTE'| translate}}
                                <p-columnFilter type="text" field="Caste_Description" display="menu"></p-columnFilter>
                                <p-sortIcon field="Caste_Description"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Village">{{'VILLAGE'| translate}}
                                <p-columnFilter type="text" field="Village" display="menu"></p-columnFilter>
                                <p-sortIcon field="Village"></p-sortIcon>
                            </th>
                            <th pSortableColumn="VendorName">{{'VENDOR_NAME'| translate}}
                                <p-columnFilter type="text" field="VendorName" display="menu"></p-columnFilter>
                                <p-sortIcon field="VendorName"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Scheme">{{'SCHEME'| translate}}
                                <p-columnFilter type="text" field="Scheme" display="menu"></p-columnFilter>
                                <p-sortIcon field="Scheme"></p-sortIcon>
                            </th>
                            <th pSortableColumn="AutoId">{{'AUTO_ID'| translate}}
                                <p-columnFilter type="text" field="AutoId" display="menu"></p-columnFilter>
                                <p-sortIcon field="AutoId"></p-sortIcon>
                            </th>
                            <th pSortableColumn="">{{'VIEW_APPLICATION'| translate}}</th>

                            <th pSortableColumn="">{{'ESTIMATION_ACTION'| translate}}</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-product>
                        <tr [ngStyle]="{'background-color': product.PhyVerificationStatus==1  ? '#e6ffe6' : '#ffffff'}">
                            <td>{{product.AppID}}</td>
                            <td>{{product.DateOfReg}}</td>
                            <td>{{product.FarmerName}}</td>
                            <td>{{product?.Caste_Description}}</td>
                            <td> {{product.Village}}</td>
                            <td> {{product.VendorName}}</td>
                            <td> {{product.Scheme}}</td>
                            <td> {{product.AutoId}}</td>
                            <td>
                                <button pButton pRipple pTooltip="view application" icon="pi pi-file"
                                    class="p-button-rounded p-button-accent mr-1 btnSize"
                                    (click)="selectPhysicalVerAppln(product)"></button>
                                <!-- <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning"
                                            (click)="deleteProduct(product)"></button> -->
                            </td>
                            <td *ngIf="product.PhyVerificationStatus==2">
                                <button pButton pRipple type="button" pTooltip="Add-Estimation" icon="pi pi-plus"
                                    class="p-button-rounded p-button-text"
                                    (click)="selectPhysicalVerAppln(product)"></button>
                            </td>
                            <td *ngIf="product.PhyVerificationStatus==1">
                                <button pButton pRipple type="button" pTooltip="Edit-Estimation"
                                    (click)="selectPhysicalVerAppln(product)" icon="pi pi-pencil"
                                    class="p-button-rounded p-button-text"></button>
                                <button pButton pRipple type="button" pTooltip="Delete-Estimation" icon="pi pi-times"
                                    class="p-button-rounded p-button-text p-button-danger"
                                    (click)="deletePhysicalVerAppln(product)"></button>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="summary">
                        <div class="flex align-items-center justify-content-between">
                            {{'IN_TOTAL_THERE_ARE'| translate}} {{ changeReqApplications ?
                                changeReqApplications.length : 0 }} {{'DETAILS_ADDED'| translate}}.
                        </div>
                    </ng-template>
                </p-table>
            </div>
        </p-card>
    </div>
</div>

<p-confirmDialog [style]="{width: '400px'}"></p-confirmDialog>